import { COLOR_BASE_GREY_100, PAGE_MARGIN_L, SPACING_XS_S } from '@audi/audi-ui-design-tokens';
import { Text } from '@oneaudi/unified-web-components';

import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const TotalPriceSection = styled.div`
	flex-direction: row;
	flex-wrap: wrap;
	display: flex;
	gap: 0px ${SPACING_XS_S}px;
	align-items: center;
`;

export const PriceBarTotalPrice = styled.div``;

// eslint-disable-next-line
// @ts-ignore
export const TotalPricePrefix = styled(Text).attrs(() => ({
	tag: 'p',
	variant: { type: 'copy', order: '2', style: 'normal' },
	className: 'calculation-info-item',
}))``;

// eslint-disable-next-line
// @ts-ignore
export const TotalPrice = styled(Text).attrs(() => ({
	tag: 'p',
	variant: { type: 'copy', order: '1', style: 'bold' },
	className: 'calculation-info-item',
}))``;

export const MonthlyPrice = styled(TotalPrice)`
	position: relative;
`;

export const CalculationInfoStyle = styled.div<{ $view?: string }>`
	display: flex;
	align-items: ${({ $view }) => ($view === 'summary' ? 'end' : 'center')};
	justify-content: ${({ $view }) => ($view === 'summary' ? 'space-between' : 'unset')};
	gap: 24px;

	${breakPoints({
		'768': `
		gap: none;
				justify-content: unset;
			`,
	})}
	.small-icon {
		width: 24px;
		min-width: 24px;
		height: 24px;
		min-height: 24px;
		padding: 0;
	}

	.text-grey {
		color: ${COLOR_BASE_GREY_100} !important;
		width: 100%;

		${breakPoints({
			'768': `
			width: max-content;
				flex-direction: column;
				justify-content: unset;
			`,
		})}
	}

	.calculation-info {
		display: flex;
		flex-direction: column;
		margin-right: ${PAGE_MARGIN_L}px;
		height: 55px;
		flex-grow: 0;
		flex-shrink: 0;
		width: ${({ $view }) => ($view === 'summary' ? 'auto' : '100%')};
	}

	.calculation-info.total-price {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		${breakPoints({
			'768': `
				flex-direction: column;
				justify-content: unset;
			`,
		})}
	}

	.calculation-info.total-price,
	.calculation-info.monthly-price {
		margin-right: 0;
		height: auto;
		justify-content: center;
		margin-top: auto;
		flex: 1;

		.audi-footnote-anchor__text {
			color: ${COLOR_BASE_GREY_100};
		}

		${breakPoints({
			'768': `margin-right: 32px; flex: none;`,
			'1024': `width: max-content;`,
		})}
	}

	.footer-show-price-container {
		justify-content: space-between !important;
		flex-direction: row !important;
		margin-bottom: 12px;
	}

	.calculation-info-item.loading {
		margin-right: 36px;
		align-self: center;
		margin-bottom: 12px;
		${breakPoints({
			'768': `
				margin-bottom: 0;
			`,
		})}
	}

	.calculation-info-item.more-link {
		position: relative;
		top: -16px;

		span {
			color: white;
		}

		${breakPoints({
			'768': `
				top: -8px;
			`,
		})}
		.icon__container.forward-small {
			transition:
				all 400ms ease-in-out,
				color 0s;
		}
	}

	.calculation-info-item.more-link:hover {
		.icon__container.forward-small {
			margin-left: 5px;
		}
	}

	.calculation-info-item.more-link:hover * {
		color: #b3b3b3;
	}

	.calculation-info-item,
	.calculation-info-item .text-item {
		color: ${COLOR_BASE_GREY_100};
	}

	.item-link {
		display: inline-block;
		margin-top: 6px;
	}

	.item-link-icon {
		position: relative;
		top: 6px;

		* {
			font-size: 18px;
		}
	}

	.calculation-info.monthly-price {
		display: ${({ $view }) => ($view === 'summary' ? 'flex' : 'none')};
		${breakPoints({
			'1024': `display:flex;`,
		})}
	}

	.footnote-reference {
		position: absolute;
		top: -0.2em;
	}
`;
